import {BdDunningTypeStartDto} from '../model/dto/api/bd-dunning-type-structure.dto';

/**
 * AI:
 * Status: 'generated'
 * Type: Interface
 * SubType: ViewModel
 * Reason: One accordion panel of the block „Einstieg in das Mahnverfahren (Pfade)“ in
 *         BdDunningTypeOverviewComponent: the start conditions of ONE Abrechnungsbereich.
 *
 * On a productive tenant a DunningType carries dozens of start conditions spread over many
 * billing areas, which makes the flat list unusable. The overview therefore groups them per
 * billing area — once per structure load in the component, never by a template method, so
 * change detection never re-groups.
 */
export interface BdDunningTypeStartGroup {

    /**
     * Value of the accordion panel: {@link START_GROUP_KEY_ALL} or {@code 'ba-<id>'}.
     *
     * Load bearing beyond identity: it is what the two-way bound expand state of the accordion
     * holds, so it must be stable across a reload of the same configuration.
     */
    key: string;

    /** Id of the billing area, {@code null} for the "applies to all billing areas" group. */
    billingAreaId: number | null;

    /**
     * GERMAN panel header: the name of the billing area, {@code 'Abrechnungsbereich <id>'} when
     * the relation carries no name, and „Alle Abrechnungsbereiche“ for the {@code null} group.
     */
    label: string;

    /** The start conditions of this group, in load order (orderPriority asc). */
    starts: BdDunningTypeStartDto[];

    /**
     * How many rows of this group are NOT active. Shown as a warn tag on the panel header,
     * because a collapsed panel would otherwise hide that part of the configuration has no
     * effect at runtime.
     */
    inactiveCount: number;

}

/**
 * Accordion key of the group holding the start conditions WITHOUT a billing area.
 *
 * Such a start applies to every billing area (business rule 4), which is why the group is
 * rendered first, ahead of the alphabetically ordered billing areas.
 */
export const START_GROUP_KEY_ALL = 'all';
